import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, FormattedMessage } from "gatsby-plugin-intl";
import { faMapMarkerAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import Label from "components/Label";
import Button from "components/Button";
import { OutlinedReactSelect } from "components/SelectField/ReactSelect";
import { gtagsActions, gtagsCategories, gtagsSend } from "utils/gtagsUtils";

const Form = ({
  className,
  citiesData,
  searchedCity,
  onChange,
  citiesLoadingError,
  citiesLoading,
}) => {
  const citiesList = useMemo(() => {
    if (citiesData?.content) {
      const cities = citiesData.content.map(item => ({
        value: item.name,
        label: item.name,
        ...item,
      }));
      return cities || [];
    }
    return [];
  }, [citiesData]);
  const [quartier, setQuartier] = useState("");

  return (
    <div
      className={classNames(
        className,
        "flex flex-wrap items-center shadow-lg py-6 md:py-4 pl-5 pr-4 bg-white border border-gray-100 rounded-lg"
      )}
    >
      <div className="w-full md:w-6/12 mb-4 md:mb-0 home-find-branch__dropdown">
        <Label
          className="uppercase block"
          textClasses="ltr:ml-2 rtl:mr-2"
          icon={faMapMarkerAlt}
          iconType="aly"
          labelKey="branches.city"
        />
        <OutlinedReactSelect
          placeholder="Casablanca"
          options={citiesList}
          value={searchedCity.name}
          onChange={option => onChange(option)}
          loading={citiesLoading}
        />
        {citiesLoadingError && (
          <div className="text-sm text-red-600 bg-red-200 px-2 py-2 mt-2 rounded-sm">
            <FormattedMessage id="errors.citiesLoading" />
          </div>
        )}
      </div>
      <div className="w-full md:w-6/12 mb-4 md:mb-0 home-find-branch__dropdown padding-quartier">
        <Label
          className="uppercase block"
          textClasses="ltr:ml-2 rtl:mr-2"
          icon={faMapMarkerAlt}
          iconType="aly"
          labelKey="Quartier"
        />
        <input
          name="quartier"
          type="text"
          placeholder="Quartier"
          onChange={event => setQuartier(event.target.value)}
          className="input-quartier react-select-outlined"
        />
      </div>

      <div className="w-full md:w-5/12 md:ltr:mx-auto py-4 md:rtl:mr-auto">
        <Button
          className={`w-full ${
            !searchedCity.id && "pointer-events-none opacity-50"
          }`}
          variant="default"
          startIcon={<FontAwesomeIcon icon={faSearch} />}
          component={Link}
          to={`/agency/?city=${searchedCity.id}&quartier=${quartier}`}
          state={{ fromFeed: true }}
          onClick={() =>
            gtagsSend(gtagsCategories.SEARCH, gtagsActions.FIND_AGENCY)
          }
        >
          <FormattedMessage id="branches.findBranch" />
        </Button>
      </div>
    </div>
  );
};

Form.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  citiesData: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    content: PropTypes.array,
  }),
  searchedCity: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
  }),
};

export default Form;
